import React from "react";
import { useSnapshot } from "valtio";

import {
    setActiveSubTab,
    setIsWaysTabActive,
    setIsConfigured,
    resetDesignStore,
    generalConfigStore,
    computedStore,
    designStore,
} from "@store";
import kioskSettingStore from "@pages/GeneralConfig/store";
import { store as storeGlobal } from "@components/VerticalLayout/store";
import { useSelector } from "react-redux";

import {
    useProjectMigrations,
    useTemplateScreenInit,
    useProjectDerivedFlagsSync,
    useInitialInformationModesCheck,
} from "./hooks";
import { buildTabs } from "./tabs";
import { SideNav } from "./SideNav";
import { TabBody } from "./TabBody";

import "./index.css";

export function ModalContentWrapper(): JSX.Element {
    const mainColor = useSelector(
        (state: any) => state.global.infoUser.maincolor
    );
    const {
        isWaysTabActive,
        chosenTemplate,
        activeSubTab,
        isCustomerAccountActive,
        project,
        templates,
        isInformationModesEmpty,
        isConfigured,
        transitions,
    } = useSnapshot(generalConfigStore);
    const { isKioskSetting } = useSnapshot(kioskSettingStore);
    const { elements } = useSnapshot(computedStore);
    const { activeSlideIndex, activePageName } = useSnapshot(designStore);
    const { fideltyType, shopID, oneShop } = useSnapshot(storeGlobal);
    const [activeTab, setActiveTab] = React.useState<number>(0);
    const [isSubMenuCollapsed, setIsSubMenuCollapsed] = React.useState<boolean>(
        isKioskSetting
    );
    const shop_id = oneShop ? shopID : project.shopId ?? shopID;

    const tabs = React.useMemo<TabsMenuType[]>(
        () => buildTabs(isConfigured, isKioskSetting),
        [isConfigured, isKioskSetting]
    );

    const toggleNav = React.useCallback((tab: number, openSubMenu: boolean) => {
        setActiveTab((prev) => (prev !== tab ? tab : prev));
        if (openSubMenu) {
            setIsSubMenuCollapsed(true);
        } else {
            setIsSubMenuCollapsed((prev) => (prev ? false : prev));
        }
    }, []);

    const toggleSubNav = React.useCallback((tab: number) => {
        setActiveSubTab(tab);
    }, []);

    React.useEffect(() => {
        if (project.template.id !== "") {
            const waysIdx = tabs.findIndex((item) => item.id === "ways");
            setIsWaysTabActive(waysIdx === activeTab);
            setIsConfigured(true);
        }
    }, [tabs, activeTab, project.template.id]);

    React.useEffect(() => {
        setActiveTab(0);
        setActiveSubTab(0);
        return () => {
            resetDesignStore();
        };
    }, []);

    useProjectMigrations(project);
    useTemplateScreenInit(project, templates);
    useProjectDerivedFlagsSync({
        project,
        elements,
        activeSlideIndex,
        fideltyType,
        shop_id,
        transitions,
        activeSubTab,
        activePageName,
    });
    useInitialInformationModesCheck(project);

    return (
        <div
            className="d-grid__clz h-100"
            style={{ gridTemplateColumns: "220px 1fr" }}
        >
            <SideNav
                tabs={tabs}
                activeTab={activeTab}
                activeSubTab={activeSubTab}
                isSubMenuCollapsed={isSubMenuCollapsed}
                mainColor={mainColor}
                chosenTemplateName={chosenTemplate.name}
                isCustomerAccountActive={isCustomerAccountActive}
                isInformationModesEmpty={isInformationModesEmpty}
                onTabClick={toggleNav}
                onSubTabClick={toggleSubNav}
            />

            <TabBody
                tabs={tabs}
                activeTab={activeTab}
                activeSubTab={activeSubTab}
                isSubMenuCollapsed={isSubMenuCollapsed}
                isWaysTabActive={isWaysTabActive}
            />
        </div>
    );
}
